import React from "react";
import { UsersSettingsTab } from "./tabs";
import { SearchBox } from "@/components/SearchBox";
import { Dropdown, DropdownOption } from "@/components/Dropdown";

type UserFiltersProps = {
  selectedTab: UsersSettingsTab;
  setSelectedTab: (tab: UsersSettingsTab) => void;
  statusOptions: DropdownOption<UsersSettingsTab>[];
  businessOptions: DropdownOption<string>[];
  selectedBusinessId?: string;
  onSelectBusiness: (businessId: string) => void;
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
};

export function UserFilters({
  selectedTab,
  setSelectedTab,
  statusOptions,
  businessOptions,
  selectedBusinessId,
  onSelectBusiness,
  searchTerm,
  onSearchTermChange,
}: UserFiltersProps) {
  return (
    <div className="flex space-x-4 items-center">
      <Dropdown
        options={statusOptions}
        selectedOption={selectedTab}
        onSelect={setSelectedTab}
        label="Account type"
        alignment="left"
      />

      {businessOptions.length > 1 && (
        <Dropdown
          options={businessOptions}
          selectedOption={selectedBusinessId || ""}
          onSelect={onSelectBusiness}
          placeholder="Select Business"
          menuClassName="min-w-40"
          alignment="right"
        />
      )}

      <div className="ml-auto! flex">
        <SearchBox term={searchTerm} onTermChanged={onSearchTermChange} placeholder="Search" />
      </div>
    </div>
  );
}
